import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "col-md-8 col-lg-6 offset-md-2 offset-lg-3" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = {
  key: 0,
  class: "alert alert-success",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "card-header" }, "Підтвердіть вашу Email адресу", -1)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isResended)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Посилання для відновлення паролю надіслано на вашу пошту. Перейдіть за посиланням та вкажіть новий пароль. "))
          : _createCommentVNode("", true),
        _cache[1] || (_cache[1] = _createTextVNode(" Перш ніж продовжити, перевірте свою електрону пошту на наявність посилання для підтвердження. Якщо Ви не отримали листа, ")),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resend && _ctx.resend(...args)), ["prevent"])),
          class: "btn btn-link p-0 m-0 align-baseline"
        }, "натисніть тут для відправки нового"),
        _cache[2] || (_cache[2] = _createTextVNode(". "))
      ])
    ])
  ]))
}